import { Link, useLocation } from "react-router-dom";
import { useMe } from "../api/me";

/** The same pill as the shell's navigation (`navClass` in `Shell.tsx`). */
const pill = (active: boolean) =>
  [
    "inline-flex min-h-[44px] items-center rounded-pill px-3 py-1.5 text-sm font-semibold transition-colors sm:min-h-0",
    active
      ? "bg-brand-tint text-brand-dark"
      : "text-slate-600 hover:bg-white/70 hover:text-brand-dark",
  ].join(" ");

/** The row under the page header of every page of the 3D library. Which pill
 *  is active comes from the path, and the pills are plain links: the section's
 *  pages do not nest under one another, so `NavLink`'s own matching would mark
 *  Browse as current on every page under `/assets` and Import on none under
 *  `/assets/imports`. */
export function SectionHeader() {
  const { pathname } = useLocation();
  const features = useMe().data?.features;
  const designActive = pathname.startsWith("/assets/studio");
  const importActive =
    pathname === "/assets/import" || pathname.startsWith("/assets/imports");
  const browseActive =
    pathname.startsWith("/assets") && !designActive && !importActive;
  return (
    <nav
      aria-label="Objects"
      className="mb-6 flex flex-wrap items-center gap-1"
    >
      <Link
        to="/assets"
        className={pill(browseActive)}
        aria-current={browseActive ? "page" : undefined}
      >
        Browse
      </Link>
      {features?.studio ? (
        <Link
          to="/assets/studio"
          className={pill(designActive)}
          aria-current={designActive ? "page" : undefined}
        >
          Design
        </Link>
      ) : null}
      {features?.imports ? (
        <Link
          to="/assets/import"
          className={pill(importActive)}
          aria-current={importActive ? "page" : undefined}
        >
          Import
        </Link>
      ) : null}
      <Link
        to="/help/3d-library"
        className="ml-auto inline-flex min-h-[44px] items-center text-sm underline sm:min-h-0"
        aria-current={pathname === "/help/3d-library" ? "page" : undefined}
      >
        Help
      </Link>
    </nav>
  );
}
